/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import PhotoFilterComponent from "./PhotoFilterComponent";
import PhotoPopUp from '../PhotoPopUp';
import loadImage from "../../loader.svg";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {useThemeData} from '../../context/ThemeDataContext'

function PhotoComponent(props) {
    const {site_id} = useThemeData().themeData.site;
    const {greenscreen_default_background} = useThemeData().modules;
    const {
        border_radius,
        primary_color_4,
        background_color_2,
        background_color_5
    } = useThemeData().themeData.site.theme;
    const PHOTO_URL = process.env.REACT_APP_PHOTO_URL;
    const PRODUCT_URL = process.env.REACT_APP_PRODUCT_URL;
    const APP_URL = process.env.REACT_APP_SITE_URL
    const [message, setMessage] = useState(false)
    const [product_color, setProductColor] = useState(props.product_color);
    const { updateIsPNG, product_color: newProductColor } = props;
    const [isPNG, setIsPNG] = useState(false);

    // Construct the full image URL
    const fullImageUrl = `${PHOTO_URL}${site_id}/${props.folder_id}/0/0/0/0/${props.photo_id}/${props.photo_file_name}`;

    // Fetch headers to determine MIME type
    useEffect(() => {
        let isMounted = true;

        const checkImageType = async () => {
            try {
                const response = await fetch(fullImageUrl, { method: 'HEAD' });
                const contentType = response.headers.get('Content-Type');
                const isImagePNG = contentType === 'image/png';

                setIsPNG((prevIsPNG) => {
                    if (prevIsPNG !== isImagePNG) {
                        if (updateIsPNG) {
                            updateIsPNG(isImagePNG);
                        }
                        return isImagePNG;
                    }
                    return prevIsPNG;
                });
            } catch (error) {
                console.error('Error fetching headers:', error);
                setIsPNG((prevIsPNG) => {
                    if (prevIsPNG !== false) {
                        if (updateIsPNG) {
                            updateIsPNG(false);
                        }
                        return false;
                    }
                    return prevIsPNG;
                });
            }
        };

        checkImageType();

        return () => {
            isMounted = false;
        };
    }, [fullImageUrl]);



    useEffect(() => {
        if (product_color !== newProductColor) {
            setProductColor(newProductColor);
        }
    }, [newProductColor, product_color]);

    const closePopup = () => {
        setMessage(false);
    }

    let product_combivel_id = 0;
    if (props.product_combivel_id === null || props.product_combivel_id === undefined) {
        product_combivel_id = 0;
    } else {
        product_combivel_id = props.product_combivel_id;
    }

    let effect_id = 0;
    if (props.effect_id === null) {
        effect_id = 0;
    } else {
        effect_id = props.effect_id;
    }

    let effect_file_id_for = 0;
    if (props.effect_file_id_for === null) {
        effect_file_id_for = 0;
    } else {
        effect_file_id_for = props.effect_file_id_for;
    }

    let color = '0';
    if (props.product_colors !== undefined && props.product_colors !== null && props.product_colors !== '') {
        let color_string = props.product_colors.split(";");
        color = '0';
        if (color_string.length === 1) {
            color = color_string[0];
        }
    } else {
        color = '0';
    }

    if (props.type === 1) {
        if (props.product_color === 'Kleur' && props.product_type !== 'pakket') {

            // console.log(props.product_color);

            return (
                // photo in shoppage without filter
                <div
                    style={{
                        width: `100%`,
                        display: `inline-block`
                    }} className="text-center">
                    <div className="photoBox">
                        <div className=""
                             onClick={() => setMessage(!message)}>
                            {props.variation_product_image ? (
                                <img
                                    // src={`${props.variation_product_image}`}
                                    alt={props.variation_product_image}
                                    className="img-sizing product_afbeelding filter2"
                                />
                            ) : props.product_image !== 'producten/' ? (
                                    <LazyLoadImage
                                        src={`${PRODUCT_URL}${site_id}/${props.photo_id}/${props.product_id}/${props.photo_file_name}`}
                                        alt={props.product_image}
                                        className="img-sizing product_afbeelding filter2"
                                        placeholderSrc={loadImage}
                                    />
                            ) : null}
                            {props.effect_file_id_for !== 0 || props.effect_id !== 0  ?
                                <img
                                    className="img-sizing effect_achter filter4"
                                    src={`${PHOTO_URL}${site_id}/${props.folder_id}/${product_combivel_id}/${effect_id}/${effect_file_id_for}/0/${props.photo_id}/${props.photo_file_name}`}
                                    id={props.photo_id}
                                    alt={props.photo_file_name}
                                    style={{
                                        cursor: 'zoom-in',
                                        border: `1px solid ${background_color_5}`
                                    }}
                                />
                                :
                                <div style={{
                                    width: '100%'
                                }}>
                                    {props.product_type !== 'divers' &&
                                        <img
                                            src={`${PHOTO_URL}${site_id}/${props.folder_id}/${product_combivel_id}/0/0/${color}/${props.photo_id}/${props.photo_file_name}`}
                                            alt={props.photo_file_name}
                                            className="img-sizing filter3"
                                            id={props.photo_id}
                                            style={{
                                                cursor: 'zoom-in',
                                                border: `1px solid ${background_color_5}`
                                            }}
                                            // retry={{count: 5, delay: 3, accumulate: 'add'}}
                                        />}
                                </div>
                            }
                        </div>
                    </div>
                    <PhotoPopUp
                        // zoom={zoom}
                        // closePopupZoom={closePopupZoom}
                        product_type={props.product_type}
                        product_id={props.product_id}
                        photo_file_name={props.photo_file_name}
                        site_id={site_id}
                        folder_id={props.folder_id}
                        product_combivel_id={product_combivel_id}
                        background_color_5={props.background_color_5}
                        t={props.t}
                        photo_id={props.photo_id}
                        message={message}
                        closePopup={closePopup}
                        primary_color_4={primary_color_4}
                        background_color_2={background_color_2}
                        border_radius={border_radius}
                        effect_id={props.effect_id}
                        effect_file_id_for={props.effect_file_id_for}
                        effect_file_name={props.effect_file_name}
                        photo_color={color}
                    />

                    {/*{message ?*/}
                    {/*    <PopUpComponent*/}
                    {/*        primary_color_4={primary_color_4}*/}
                    {/*        background_color_2={background_color_2}*/}
                    {/*        border_radius={border_radius}*/}
                    {/*        content={<div style={{ backgroundImage: `url(${props.effect_file_name}`, backgroundSize: 'cover', textAlign: 'center' }}>*/}
                    {/*          <img*/}
                    {/*              src={`${PHOTO_URL}${site_id}/${props.folder_id}/0/${props.effect_id}/0/${props.photo_id}/${props.photo_file_name}`}*/}
                    {/*              className="img-sizing-1"*/}
                    {/*              id={props.photo_id}*/}
                    {/*              alt={props.photo_file_name}*/}
                    {/*              // retry={{count: 5, delay: 3, accumulate: 'add'}}*/}
                    {/*              style={{border: `1px solid ${background_color_5}`}}*/}
                    {/*          />*/}
                    {/*        </div>}*/}
                    {/*        btn2={props.t('Go back')}*/}
                    {/*        closePopup={closePopup.bind(this)}*/}
                    {/*    />*/}
                    {/*    : null}*/}
                </div>
            );
        } else {
            // photo in shoppage with filter and 'pakketten'
            return (<>
                {
                    /* photos in shop. pakketten, combi's and normal */
                    <div>{props.product_name}</div>
                }
                <PhotoFilterComponent
                    groepsfoto={props.groepsfoto}
                    updatePhotoFileName={props.updatePhotoFileName}
                    Index={props.Index}
                    file_changed={props.file_changed}
                    product_image={props.product_image}
                    class_id={props.class_id}
                    child_product_type={props.child_product_type}
                    child_product_file={props.child_product_file}
                    pakket_selectie_alle_inlogs={props.pakket_selectie_alle_inlogs}
                    pakket_selectie={props.pakket_selectie}
                    login_name={props.login_name}
                    product_combivel_id={product_combivel_id}
                    product_child_id={props.product_child_id}
                    product_child_formaat={props.product_child_formaat}
                    product_child_colors={props.product_child_colors}
                    product_id={props.product_id}
                    product_type={props.product_type}
                    photo_id={props.photo_id}
                    photo_file_name={props.photo_file_name}
                    product_color={props.product_color}
                    folder_id={props.folder_id}
                    effect_file_name={props.effect_file_name}
                    effect_id={effect_id}
                    effect_file_id_for={effect_file_id_for}
                />
            </>);
        }
    } else {
        // photo in shoppingcart
        if (props.photoType === 1) {
            return (<div onClick={() => setMessage(!message)}>
                    {props.product_type === 'divers' ?
                        <div className="photoBox twee">
                            <LazyLoadImage
                                src={`${PRODUCT_URL}${site_id}/${props.photo_id}/${props.product_id}/${props.photo_file_name}`}
                                alt={props.product_image}
                                className="img-sizing product_afbeelding filter2"
                                placeholderSrc={loadImage}
                            />
                        </div>
                        :
                        <PhotoFilterComponent
                            effect_file_name={props.effect_file_name}
                            effect_file_id={props.effect_file_id}
                            effect_file_name_for={props.effect_file_name_for}
                            effect_file_id_for={props.effect_file_id_for}
                            photoType={props.photoType}
                            photo_file_name={props.photo_file_name}
                            photo_id={props.photo_id}
                            login_name={props.login_name}
                            product_id={props.product_id}
                            combivel_id={props.combivel_id}
                            product_color={props.product_color}
                            product_type={props.product_type}
                            folder_id={props.folder_id}
                        />}
                    <PhotoPopUp
                        // zoom={zoom}
                        // closePopupZoom={closePopupZoom}
                        product_type={props.product_type}
                        product_id={props.product_id}
                        photo_file_name={props.photo_file_name}
                        site_id={site_id}
                        folder_id={props.folder_id}
                        product_combivel_id={props.combivel_id}
                        effect_id={props.effect_file_id}
                        effect_for_id={props.effect_file_id}
                        background_color_5={props.background_color_5}
                        t={props.t}
                        photo_id={props.photo_id}
                        message={message}
                        closePopup={closePopup}
                        primary_color_4={primary_color_4}
                        background_color_2={background_color_2}
                        border_radius={border_radius}
                        effect_file_name={props.effect_file_name}
                        effect_file_name_for={props.effect_file_name_for}
                        effect_file_id_for={props.effect_file_id_for}
                        photo_color={props.product_color}
                    />
                </div>
            );
        } else {
            if (props.headPhotoType === 1) {
                // main photo in shoppage

                return (
                    <div className="div-position">
                        <img
                            onClick={() => setMessage(!message)}
                            src={`${PHOTO_URL}${site_id}/${props.folder_id}/0/0/0/0/${props.photo_id}/${props.photo_file_name}`}
                            id={props.photo_id}
                            // src={`${PHOTO_URL}${site_id}/tmp/foto_genereer/${props.photo_id}_${props.photo_file_name}`}
                            alt={props.photo_file_name}
                            className={`img-position img-sizing`}
                            style={{
                                border: `1px solid ${background_color_5}`,
                                cursor: 'zoom-in',
                                height: 400,
                                backgroundImage:
                                    greenscreen_default_background
                                        ? `url(${APP_URL}${site_id}/userfiles/effecten/${greenscreen_default_background})`
                                        : `url(''`,
                                backgroundSize: `contain`
                            }}/>
                        <PhotoPopUp
                            // zoom={zoom}
                            // closePopupZoom={closePopupZoom}
                            product_type={props.product_type}
                            product_id={props.product_id}
                            photo_file_name={props.photo_file_name}
                            site_id={site_id}
                            folder_id={props.folder_id}
                            product_combivel_id={0}
                            background_color_5={props.background_color_5}
                            t={props.t}
                            photo_id={props.photo_id}
                            message={message}
                            closePopup={closePopup}
                            primary_color_4={primary_color_4}
                            background_color_2={background_color_2}
                            border_radius={border_radius}
                            effect_id={0}
                            effect_file_id_for={0}
                            effect_file_name={props.effect_file_name}
                            photo_color={color}
                        />
                    </div>
                );
                // main photo from shoppage in photoLoginShare
            } else {
                return (
                    <div className="div-position">
                        <img
                            src={`${PHOTO_URL}${site_id}/${props.folder_id}/0/0/0/0/${props.photo_id}/${props.photo_file_name}`}
                            id={props.photo_id}
                            // src={`${PHOTO_URL}${site_id}/tmp/foto_genereer/${props.photo_id}_${props.photo_file_name}`}
                            alt={props.photo_file_name}
                            className="img-sizing"
                            style={{
                                border: `1px solid ${background_color_5}`
                            }}/>
                    </div>
                );
            }
        }
    }
}


export default React.memo(withTranslation('productdetailComponent')(PhotoComponent));


